// Status codes per entity (spec §4). Entries marked "assumed" are not in the workflow deck;
// they drive the UI and must be confirmed with the backend team.

export const ProgrammeStatus = {
  AVAILABLE_FOR_ANCHOR_SETUP: 'AVAILABLE_FOR_ANCHOR_SETUP',
  VALIDATION_FAILED: 'VALIDATION_FAILED', // assumed: Stage 1 "validation result"
} as const
export type ProgrammeStatus = (typeof ProgrammeStatus)[keyof typeof ProgrammeStatus]

export const AnchorStatus = {
  DRAFT: 'DRAFT', // assumed
  SUBMITTED: 'SUBMITTED', // assumed
  ANCHOR_STATUS_ACTIVE: 'ANCHOR_STATUS_ACTIVE',
  AVAILABLE_FOR_SUPPLIER_ONBOARDING: 'AVAILABLE_FOR_SUPPLIER_ONBOARDING',
  // backend AnchorStatus enum (GET /enums/AnchorStatus)
  UNDER_SETUP: 'UNDER_SETUP',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  CLOSED: 'CLOSED',
} as const
export type AnchorStatus = (typeof AnchorStatus)[keyof typeof AnchorStatus]

export const SupplierStatus = {
  NOMINATED: 'NOMINATED', // assumed
  INVITED: 'INVITED', // assumed
  REGISTRATION_IN_PROGRESS: 'REGISTRATION_IN_PROGRESS', // assumed
  PENDING_BANK_REVIEW: 'PENDING_BANK_REVIEW',
  SUPPLIER_APPROVED_FOR_PROGRAMME: 'SUPPLIER_APPROVED_FOR_PROGRAMME',
  SUPPLIER_REJECTED: 'SUPPLIER_REJECTED', // assumed
  // backend SupplierStatus enum (GET /enums/SupplierStatus): the supplier master profile
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  CLOSED: 'CLOSED',
} as const
export type SupplierStatus = (typeof SupplierStatus)[keyof typeof SupplierStatus]

export const InvoiceStatus = {
  RECEIVED: 'RECEIVED', // assumed
  INVOICE_ELIGIBLE: 'INVOICE_ELIGIBLE',
  INVOICE_INELIGIBLE: 'INVOICE_INELIGIBLE',
  AVAILABLE_FOR_FINANCING_REQUEST: 'AVAILABLE_FOR_FINANCING_REQUEST',
  LOCKED_FOR_FINANCING: 'LOCKED_FOR_FINANCING', // assumed
} as const
export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]

/** Stages 5–9: request, LOS decision, booking, settlement and recovery. */
export const FinancingStatus = {
  FINANCING_REQUEST: 'FINANCING_REQUEST',
  PENDING_BANK_REVIEW: 'PENDING_BANK_REVIEW',
  REFERRED: 'REFERRED',
  APPROVED: 'APPROVED',
  CONDITIONALLY_APPROVED: 'CONDITIONALLY_APPROVED',
  REJECTED: 'REJECTED',
  READY_FOR_BOOKING: 'READY_FOR_BOOKING',
  BOOKED: 'BOOKED',
  FINANCING_DISBURSED: 'FINANCING_DISBURSED',
  BOOKING_FAILED: 'BOOKING_FAILED',
  DISBURSEMENT_FAILED: 'DISBURSEMENT_FAILED',
  SETTLED: 'SETTLED',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  OVERDUE: 'OVERDUE',
  CURED: 'CURED',
  RESTRUCTURED: 'RESTRUCTURED',
  DEFAULTED: 'DEFAULTED',
  WRITTEN_OFF: 'WRITTEN_OFF',
} as const
export type FinancingStatus = (typeof FinancingStatus)[keyof typeof FinancingStatus]

export const CollectionStatus = {
  DUE: 'DUE', // assumed: a scheduled collection that is not yet paid
  SETTLED: 'SETTLED',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  OVERDUE: 'OVERDUE',
} as const
export type CollectionStatus = (typeof CollectionStatus)[keyof typeof CollectionStatus]
